import React, {  useState } from "react"
import { Card } from "../../../../Common/fCards"
import { numberWithCommas } from "../../../../../Utils/NumberToComma"
import Moment from 'moment';
import Empty from "../../../../Common/fCard/Empty";
import _ from  'lodash';
import AdvanceDetails from "./AdvanceDetails";


export default ({items=[],style})=>{

    const [value,setValue] = useState('')
    const [open,setOpen] = useState(undefined)
    const  mapCard = (item) =>{
        let data = item.details.data && JSON.parse(item.details.data)

        return(
        <Card  key={`Invoice-${item.id}`}
            flag={{value: item.title}}
            headings={[`${data.currency||'INR'} ${numberWithCommas(data.amount)}`, data.owner.ownerName]}
            details={[{label: 'Date', value: Moment(data.createdAt).format(" hh:mm a DD MMM YY")}, {label: 'Invoice ID', value: data.invoiceId}, {label: 'Category', value: data.category},{label: 'Service', value: data.service}]}
            onClick={()=>{
                if(item.formType === 'vendor-advance')   setOpen(item.formId)
                if(item.formType === 'vendor-invoice') {
                    setOpen(undefined)
                 window.open(`/app/banking/invoice/${data.id}`,'_blank')
                }
            }}
            style={style}
            >
                {_.size(item.integrationData) > 0 && item.integrationData['postingSynced'] && (
                    <div style={{
                        padding: '4px 5px', marginBottom: '5px', borderRadius: '5px', position: 'relative',marginLeft:'23%',fontSize: '11px', color: '#fff', background: 'rgb(78 185 135)'
                  }}>Posting Synced successfully</div>
                )} 
          </Card>
        )
    }


  const onFilter =(value)=> {
       return items.filter((e) => JSON.stringify(e).toLowerCase().includes(value.toLowerCase()))
     }

   const  onFilterModules =(val)=>{
        setValue(val)
    }

   const invoices =  onFilter(value)

    return(
        <div>
           <div style={{ display: 'flex', position: 'relative', marginTop: '20px', marginBottom: '20px'}}>
            {items.length > 0  && 
                    <div style={{ flex: '1 1 0%', height: '40px', borderRadius: '1px' }}>
                        <input style={{ height: '100%', width: '94%', border: '1px solid #ddd', backgroundColor: 'rgb(255,255,255)', fontSize: '16px', borderRadius: '8px', padding: '16px' }}
                            type='text'
                            placeholder="Search invoice .."
                            onChange={(e)=>{onFilterModules(e.target.value)}}
                        />
                    </div>
              }
            </div>
              {invoices.length>0 ?
                <div style={{display:'flex',flexWrap:'wrap',marginTop:20}}>
                    {invoices.map(mapCard)}
                </div>:
                <div style={{marginLeft:20}}>
                     <Empty />
                </div>
            }
            {
                open ?
                <AdvanceDetails 
                    pending={true}
                    onClose={()=>{setOpen(undefined)}} 
                    data={{id:open}}
                />:
                null
            }

        </div>
    )
}